import { usePlatformStore } from "@/store/platform/platform";
import { unavailableModuleCodes } from "@/constantes/module";
import { useTriadStore } from "@/store/triad/triad";
import router from "@/router";

class ModuleManager {
  moduleIsAvailable(item) {
    return !unavailableModuleCodes.includes(item.code);
  }

  isModuleActive(moduleCode, platformStore = usePlatformStore()) {
    const isPlatformActive = platformStore.modulesAvailable.some((module) => module.code === moduleCode);
    if (!isPlatformActive) return false;

    const triadStore = useTriadStore();
    const isDashboardPage = router.currentRoute.value.matched.some((item) => item.name === "DashboardLayout");
    if (isDashboardPage) {
      const menu = triadStore.triad?.menu;
      if (menu && Object.keys(menu).length > 0) {
        return Object.values(menu).some((item) => item.code === moduleCode);
      }
    }

    return true;
  }
}

export const moduleManager = new ModuleManager();
